module.exports = __webpack_public_path__ + "static/FSS_HowItWorks1-a559dbb4d9706e89aa0ad37f277787e8.png";